import { useLang } from "../lib/i18n";
import { PROFILE } from "../lib/profile";
import { Facebook, Linkedin, MessageCircle } from "lucide-react";

export const Footer = () => {
    const { t } = useLang();
    const year = new Date().getFullYear();

    return (
        <footer
            className="relative bg-navy text-cream py-16 md:py-20"
            data-testid="footer"
        >
            <div className="absolute inset-0 grain pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="font-display text-3xl md:text-4xl">
                            Gilberto<span className="text-accentblue">.</span>Veliz
                        </div>
                        <div className="mt-2 text-cream/50 text-sm tracking-wide">
                            {PROFILE.handle}
                        </div>
                        <p className="mt-6 text-cream/70 text-sm leading-relaxed max-w-sm">
                            {t.footer.tagline}
                        </p>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-[10px] uppercase tracking-[0.25em] text-cream/50 mb-4">
                            {t.nav.contact}
                        </div>
                        <div className="space-y-2 text-cream/80">
                            <div data-testid="footer-phone">
                                {PROFILE.phoneDisplay}
                            </div>
                            <div>{PROFILE.city}</div>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[10px] uppercase tracking-[0.25em] text-cream/50 mb-4">
                            Social
                        </div>
                        <div className="flex items-center gap-4">
                            <a
                                href={PROFILE.whatsapp()}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="WhatsApp"
                                className="w-10 h-10 border border-cream/20 flex items-center justify-center hover:bg-cream hover:text-navy transition-colors"
                                data-testid="footer-whatsapp"
                            >
                                <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
                            </a>
                            <a
                                href={PROFILE.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                                className="w-10 h-10 border border-cream/20 flex items-center justify-center hover:bg-cream hover:text-navy transition-colors"
                                data-testid="footer-facebook"
                            >
                                <Facebook className="w-4 h-4" strokeWidth={1.5} />
                            </a>
                            <a
                                href={PROFILE.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn"
                                className="w-10 h-10 border border-cream/20 flex items-center justify-center hover:bg-cream hover:text-navy transition-colors"
                                data-testid="footer-linkedin"
                            >
                                <Linkedin className="w-4 h-4" strokeWidth={1.5} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-cream/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-cream/50">
                    <div>
                        © {year} Gilberto Veliz. {t.footer.rights}
                    </div>
                    <div className="flex gap-6">
                        <a
                            href="#privacy"
                            className="hover:text-cream transition-colors"
                            data-testid="footer-privacy-link"
                        >
                            {t.privacy.kicker}
                        </a>
                        <span>{t.footer.made}</span>
                    </div>
                </div>
            </div>

            {/* Footer end */}
        </footer>
    );
};

export default Footer;
